import type { ConnectionState } from '../../api/useAgentWebSocket';
import type { ActivityEntry, AgentStatus, SessionStatus, TokenUsage } from '../useAgentSession';

// ─── Agent Color ──────────────────────────────────────────────────────────

export interface AgentColor {
    name: string;
    /** Dark shade for backgrounds */
    primary: string;
    /** Borders/glows */
    light: string;
    /** Line color */
    gradient: string;
}

export const AGENT_COLORS: AgentColor[] = [
    { name: 'blue', primary: '#1e3a8a', light: '#3b82f6', gradient: '#60a5fa' },
    { name: 'purple', primary: '#5b21b6', light: '#8b5cf6', gradient: '#a78bfa' },
    { name: 'teal', primary: '#115e59', light: '#14b8a6', gradient: '#5eead4' },
    { name: 'amber', primary: '#78350f', light: '#f59e0b', gradient: '#fbbf24' },
    { name: 'rose', primary: '#881337', light: '#f43f5e', gradient: '#fb7185' },
];

// ─── Agent Instance ───────────────────────────────────────────────────────

export interface AgentInstance {
    agentId: string;
    position: { x: number; y: number };
    color: AgentColor;
    isExpanded: boolean;
    functionId: string | null;

    // Session state
    sessionId: string | null;
    sessionStatus: SessionStatus;
    agentStatus: AgentStatus;
    connectionState: ConnectionState;

    // Config
    model: 'sonnet' | 'opus' | 'haiku';
    autoApproveRuns: boolean;
    debugMode: boolean;

    // Activity
    entries: ActivityEntry[];
    tokenUsage: TokenUsage;

    // Spotlight target
    activeNodeId: number | null;
}

// ─── Spatial Context ──────────────────────────────────────────────────────

export interface NearbyNode {
    nodeId: number;
    nodeType: string;
    name: string;
    position: { x: number; y: number };
    distance: number;
}

export interface SpatialContext {
    agentPosition: { x: number; y: number };
    functionId: string | null;
    nearbyNodes: NearbyNode[];
}
